import url from "./sprinter-12-floorplan.webp";
export default { url };
